if (!customElements.get('collection-grid-media')) {
    class CollectionGridMedia extends HTMLElement {
        collectionGrid = null;
        gridControl = null;
        gridObserver;
        eventController = null;
        constructor() {
            super();
            this.gridObserver = new MutationObserver((mutationList) => {
                const addedElements = [];
                for (const record of mutationList) {
                    record.addedNodes.forEach((node) => {
                        if (node instanceof HTMLElement) {
                            addedElements.push(node);
                        }
                    });
                }
                if (addedElements.length) {
                    this.updateSizesAttributes(addedElements);
                }
            });
        }
        connectedCallback() {
            if (!this.collectionGrid) {
                this.collectionGrid = this.querySelector('#product-grid');
            }
            if (!this.collectionGrid)
                return;
            this.gridObserver.observe(this.collectionGrid, {
                childList: true,
            });
            this.gridControl = this.querySelector('.size_fieldset');
            if (!this.gridControl)
                return;
            this.eventController = new AbortController();
            this.gridControl.addEventListener('change', this.onGridControlChange, { signal: this.eventController.signal });
        }
        onGridControlChange = () => {
            if (!this.collectionGrid)
                return;
            const productCardList = Array.from(this.collectionGrid.querySelectorAll('.grid__item'));
            if (productCardList.length) {
                this.updateSizesAttributes(productCardList);
            }
        };
        disconnectedCallback() {
            this.gridObserver.disconnect();
            if (this.eventController)
                this.eventController.abort();
        }
        get size() {
            if (!this.collectionGrid || !this.collectionGrid.firstElementChild)
                return 0;
            return this.collectionGrid.firstElementChild.clientWidth;
        }
        updateSizesAttributes(productCardList) {
            const size = this.size.toString();
            productCardList.forEach((productCard) => {
                const images = Array.from(productCard.querySelectorAll('img.product-card__image'));
                images.forEach((image) => {
                    image.sizes = size + 'px';
                });
            });
        }
    }
    customElements.define('collection-grid-media', CollectionGridMedia);
}
